import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-additemcategory',
  templateUrl: './additemcategory.component.html',
  styleUrls: ['./additemcategory.component.css']
})
export class AdditemcategoryComponent implements OnInit{

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  saveloading: boolean;
  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  itemcategoryColl: any = [];
 

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  itemcategoryform = new FormGroup({
    itemcategoryid: new FormControl(0),
    itemcategoryname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Itemcategory";

  @Input() itemcategoryid: number = 0
  @Input() itemcategoryname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.itemcategoryid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit(){
 
    this.loginService.fnSetFirstControlFocus('itemcategoryname');
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.itemcategoryform.reset();
      this.fnInitializeItemcategory();

      if (this.itemcategoryid > 0) {
        this.fngetItemcategory();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.itemcategoryid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeItemcategory() {
    this.itemcategoryform.setValue({

      itemcategoryid: 0,
      itemcategoryname: '',
      inactive:false,
    })
  }
 
  //Get 
  fngetItemcategory() {
   
    var data = {
      'itemcategoryid': this.itemcategoryid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getItemcategory(data)
      .subscribe(
        (res) => {
          this.itemcategoryColl = res.json().result;
          var editdata = this.itemcategoryColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.itemcategoryform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'itemcategoryid': this.itemcategoryid,
          'itemcategoryname': this.itemcategoryform.get('itemcategoryname').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.itemcategoryform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckItemcategory(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.itemcategoryform.get('itemcategoryid').value > 0) {
                //Update Department
                this.fnSetItemcategory(data);
              }
              else {
                //Insert Department
                this.fnInsertItemcategory(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.itemcategoryform.controls['itemcategoryname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertItemcategory(data) {
  
    this.appService.fnInsertItemcategory(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnitemcategoryid = 0;
          if (result.length > 0) {
            rtnitemcategoryid = result[0].itemcategoryid
           
          }
          this.toastr.success('', "The new itemcategory has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.itemcategoryid);

          this.emitData.emit(rtnitemcategoryid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetItemcategory(data) {

    this.appService.fnSetItemcategory(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().result != "") {
          this.toastr.success('', "The itemcategory has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.itemcategoryid, data.itemcategoryname);

          this.emitData.emit(this.itemcategoryid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.itemcategoryform.setValue({

      itemcategoryid: deptBO.itemcategoryid,
      itemcategoryname: deptBO.itemcategoryname,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
